import $ from "jquery";
import bootbox from "bootbox";
import {getCookie} from "./gppy-misc";

let i18 = {
    "pl": {
        "Subscription cancelled": "Subskrypcja anulowana"
    }
}

function t(message) {
    if (lang === "en") return message;
    if (lang === "pl") return i18['pl'][message] ? i18['pl'][message] : message;
}

let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";

var GPPYCancelSubscription = {
    init: function () {
        $('.cancelSubscription').click(GPPYCancelSubscription.confirm);
    },

    confirm: function () {
        bootbox.confirm({
            message: gettext("Oh, keeping your subscription guarantees you the lowest possible renewal price. Are you sure want to cancel subscription?"),
            buttons: {
                confirm: {
                    label: gettext('Keep my subscription')
                },
                cancel: {
                    label: gettext('Cancel subscription')
                }
            },
            callback: function (res) {
                if (!res) {
                    fetch('/api/cancelRecurring', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/x-www-form-urlencoded',
                          'Accept': 'application/json',
                          'X-CSRFToken': getCookie('csrftoken')
                        }
                    }).then(res => res.json()).then((res) => {
                        if (res.result === "OK")
                            window.location = "/users/settings"
                        else alert("Problem with cancelling: " + res.details)
                    }).catch(() => {
                        alert("Problem with cancelling")
                    })
                }
            }
        });
    }
}

$('document').ready(GPPYCancelSubscription.init);

